<es-agreement
  agreement-label="I agree to the ExamNow Terms and Conditions"
  pdf-link="/assets/terms.pdf"
  download-label="Download Terms And Conditions"
  heading="Terms & Conditions"
  *ngIf="!userAccepted"
  (esAgreementSubmit)="onSubmit()"
>
  <iframe [src]="agreementUrl | safeSrc"></iframe>
</es-agreement>
<es-modal class="waiting-modal" [isAlert]="true" *ngIf="userAccepted">
  <es-spinner class="spinner" [bg]="'dark'" [label]="'Loading'"></es-spinner>
</es-modal>
